import React from 'react';

export const TrustYouScoreSVG: React.FunctionComponent = () => (
  <svg width="25" height="9" viewBox="0 0 25 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 9V0H7V7.13478H2.10207L0 9Z" fill="#E06F52" />
    <path d="M9 9V0H16V7.13478H11.1021L9 9Z" fill="#F3AA47" />
    <path d="M18 9V0H25V7.13478H20.1021L18 9Z" fill="#88B153" />
  </svg>
);
